import { Checkbox, FormControl, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import { TriageCustomer } from '../common/types';
import { ReactComponent as CheckboxIcon } from '../resources/images/checkbox.svg';
import { ReactComponent as CheckedCheckboxIcon } from '../resources/images/checked-checkbox.svg';
import { MappingItemProps } from './MappingItem';

export interface ConfigItemWidgetProps extends MappingItemProps {
    onAccept: (item: MappingItemProps) => void;
    renderKey: {};
    observerValue?: TriageCustomer;
}

const ConfigItem = (props: ConfigItemWidgetProps) => {
    const { onAccept, renderKey, observerValue, ...item } = props;

    return (
        <Stack className="MappingItem" height={120} borderRadius={1}>
            <Stack direction="row" className="ItemDetails">
                {!item.render && (
                    <Stack className="ItemDetailsCol1">
                        <Stack direction="column" width="385px">
                            <Typography style={{ marginRight: '3px', marginBottom: '10px' }} variant="body2">
                                {' '}
                                {item.name}{' '}
                            </Typography>
                        </Stack>
                    </Stack>
                )}
                <Stack direction="row" className="ItemDetailsCol2">
                    {item.type === 'bool' && (
                        <Checkbox
                            checkedIcon={<CheckedCheckboxIcon />}
                            icon={<CheckboxIcon />}
                            color="primary"
                            checked={item.value}
                            onChange={(event) => {
                                onAccept({ ...item, value: event.target.checked });
                            }}
                        />
                    )}
                    {item.type === 'free_text' && (
                        <TextField
                            style={{ width: '350px', background: '#ffffff' }}
                            size="small"
                            variant="outlined"
                            value={item.value}
                            type="text"
                            onChange={(event) => {
                                onAccept({ ...item, value: event.target.value });
                            }}
                        />
                    )}
                    {item.type === 'int' && (
                        <TextField
                            style={{ width: '100px', background: '#ffffff', borderRadius: '6px' }}
                            size="small"
                            variant="outlined"
                            value={item.value}
                            type="number"
                            onChange={(event) => {
                                onAccept({ ...item, value: event.target.value });
                            }}
                        />
                    )}
                    {item.type === 'select' && item.options ? (
                        <FormControl style={{ width: 350 }}>
                            <Select
                                value={item.allowMultiple ? (item.value as any[]) : item.value}
                                style={{ minWidth: '100%', maxHeight: 40, background: '#ffffff' }}
                                variant="outlined"
                                defaultValue={item.allowMultiple ? [] : ''}
                                multiple={item.allowMultiple}
                                displayEmpty
                                renderValue={(selected) => {
                                    if (item.value === '') {
                                        return <em>Select value</em>;
                                    }

                                    return item.displayProperty ? selected[item.displayProperty] : selected;
                                }}
                                onChange={(event) => {
                                    onAccept({ ...item, value: event.target.value });
                                }}
                            >
                                {item.hasEmptyItem ? (
                                    <MenuItem key={-1} value="">
                                        {'None'}
                                    </MenuItem>
                                ) : null}
                                {item.options.map((i, index) => (
                                    <MenuItem key={index} value={i}>
                                        {item.displayProperty ? i[item.displayProperty] : i}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    ) : null}
                </Stack>
                {item.type === 'custom' && item.render && renderKey[item.render]
                    ? renderKey[item.render]({
                          val: item.value,
                          setVal: (val: any) => {
                              onAccept({ ...item, value: val });
                          },
                          itemsSelection: item.options,
                          name: item.name,
                          description: item.description,
                          observerValue,
                      })
                    : null}
            </Stack>
        </Stack>
    );
};

export default ConfigItem;
